import { Component, Input } from '@angular/core';
import { Chart, ChartItem, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { constants } from '../../constants';
import { ThresholdChartData } from '../../models/threshold-chart-data.model';

Chart.register(...registerables);
Chart.register(ChartDataLabels);

@Component({
  selector: 'app-gauge-chart',
  templateUrl: './gauge-chart.component.html',
  styleUrls: ['./gauge-chart.component.css']
})
export class GaugeChartComponent {

  @Input() currentValue: number;
  @Input() locale: string;
  @Input() set data(data: ThresholdChartData[]) {
    this.chart?.destroy();
    this.chartPrint?.destroy();

    this.chart = this.getChart(<ChartItem>document.getElementById("gauge-chart"), data);
    this.chartPrint = this.getChart(<ChartItem>document.getElementById("gauge-chart-print"), data);
  }

  private chart: Chart<'doughnut'>;
  private chartPrint: Chart<'doughnut'>;

  private getChart(chartItem: ChartItem, data: ThresholdChartData[]): Chart<'doughnut'> {
    return new Chart(chartItem, {
      type: 'doughnut',
      data: {
        datasets: [
          {
            backgroundColor: data.map((data: ThresholdChartData) => data.percent === this.currentValue ? constants.RED_COLOR : data.backgroundColor),
            data: data.map(() => 1)
          }
        ]
      },
      options: {
        circumference: 180,
        rotation: 270,
        events: [],
        plugins: {
          datalabels: {
            color: data.map((data: ThresholdChartData) => data.percent === this.currentValue ? constants.WHITE_COLOR : constants.GREY_COLOR),
            display: (ctx) => ctx.chart.data.datasets[0].data.length <= 20 ? true : ctx.dataIndex % 2 === 0,
            font: (ctx) => ({
              family: 'Delivery',
              size: ctx.chart.data.datasets[0].data.length <= 10 ? 20 : Math.max(10, 20 - (ctx.chart.data.datasets[0].data.length - 10)),
              weight: 200
            }),
            formatter: (value, context) => `${data[context.dataIndex].percent}%`,

          },
          tooltip: {
            enabled: false
          },
        }
      },
    });
  }

}
